import { createReducer } from '@reduxjs/toolkit';
import { GetPickListNum, GetDeliveryList, GetItem, PostDeliveryPL, GetDeliveryDataByBatch } from './DeliveryServiceThunk';


const handleAsyncActions = (builder, action, stateKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[stateKey] = true; // Set loading for specific API
      state[stateKey] = null;
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request is fulfilled
      state[stateKey] = action.payload; // Set the fulfilled data
      state.error[errorKey] = null; // Reset error
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request fails
      state.error[errorKey] = action.payload; // Set specific error message for the API call
    });
};

const initialState = {
  GetPlNum: null,
  Getitem: null,
  PostDeliveryResponse: null,
  GetdeliveryList: null,
  DeliveryDataByBatch:null,

  // Dynamic loading and error states for each API
  loading: {
    GetPlNum: false,
    Getitem: false,
    GetdeliveryList: false,
    PostDeliveryResponse: false,
    DeliveryDataByBatch:false,
  },

  error: {
    GetPlNumError: null,
    GetitemError: null,
    GetdeliveryListError: null,
    PostDeliveryResponseError: null,
    DeliveryDataByBatchError:null
  },
};

export const deliveryReducer = createReducer(initialState, (builder) => {
  // Use the utility function to handle async actions
  handleAsyncActions(builder, GetPickListNum, "GetPlNum", "GetPlNumError");
  handleAsyncActions(builder, GetItem, "Getitem", "GetitemError");
  handleAsyncActions(builder, GetDeliveryList, "GetdeliveryList", "GetdeliveryListError");
  handleAsyncActions(builder, PostDeliveryPL, "PostDeliveryResponse", "PostDeliveryResponseError");
  handleAsyncActions(builder, GetDeliveryDataByBatch, "DeliveryDataByBatch", "DeliveryDataByBatchError");


});

export default deliveryReducer;




// import { createReducer } from '@reduxjs/toolkit';
// import { GetPickListNum,GetDeliveryList,GetItem,PostDeliveryPL} from './DeliveryServiceThunk';
// const initialState = { 
//   GetPlNum:null,
//   Getitem:null,
//   PostDeliveryResponse:null,
//   GetdeliveryList:null,
//   loading: false,
//   error: null,
// };

// export const deliveryReducer = createReducer(initialState, (builder) => {
//   builder
//     // Handle pending state for fetchGrpoData (async)
//     .addCase(GetPickListNum.pending, (state) => {
//       state.loading = true;
//     })
//     // Handle fulfilled state for fetchGrpoData (async)
//     .addCase(GetPickListNum.fulfilled, (state, action) => {
//       state.loading = false;
//       state.GetPlNum= action.payload;
//       state.error = null;
//     })
//     // Handle rejected state for fetchGrpoData (async)
//     .addCase(GetPickListNum.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;
//     })


//     .addCase(GetItem.pending, (state) => {
//       state.loading = true;
//     })
//     // Handle fulfilled state for fetchGrpoData (async)
//     .addCase(GetItem.fulfilled, (state, action) => {
//       state.loading = false;
//       state.Getitem= action.payload;
//       state.error = null;
//     })
//     // Handle rejected state for fetchGrpoData (async)
//     .addCase(GetItem.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;
//     })
//     .addCase(GetDeliveryList.pending, (state) => {
//       state.loading = true;
//     })
//     // Handle fulfilled state for fetchGrpoData (async)
//     .addCase(GetDeliveryList.fulfilled, (state, action) => {
//       state.loading = false;
//       state.GetdeliveryList= action.payload;
//       state.error = null;
//     })
//     // Handle rejected state for fetchGrpoData (async)
//     .addCase(GetDeliveryList.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;
//     })

//     .addCase(PostDeliveryPL.pending, (state) => {
//       state.loading = true;
//     })
//     // Handle fulfilled state for fetchGrpoData (async)
//     .addCase(PostDeliveryPL.fulfilled, (state, action) => {
//       state.loading = false;
//       state.PostDeliveryResponse= action.payload;
//       state.error = null;
//     })
//     // Handle rejected state for fetchGrpoData (async)
//     .addCase(PostDeliveryPL.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;
//     })

// });

// export default deliveryReducer;